<template>
    <div class="stat-card">
        <div class="stat-progress">
            <div class="stat-value" :style="{ width: `${widthPercent || 0}%` }"/>
        </div>
        <div class="stat-title" v-if="!hideTitle">
            <slot name="title">
                <span>{{ title }}</span>
            </slot>
        </div>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: Number,
                default: 0
            },
            title: {
                type: String,
                default: ''
            },
            hideTitle: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            widthPercent() {
                if (this.value < 0) {
                    return 0;
                } else if (this.value > 100) {
                    return 100;
                } else {
                    return this.value;
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
.stat-card {
    background-color: $sovis-white;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    overflow: hidden;
    color: $text-color;

    .stat-progress {
        height: 5px;
        background-color: $table-border;

        .stat-value {
            background-color: $primary-color;
            height: 100%;
        }
    }

    .stat-title {
        font-size: 12px;
        font-weight: bold;
        padding: 0.5rem 0.5rem 0 0.5rem;
    }
}
</style>